




































































































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { mapState } from 'vuex';
import {
  METHODS,
  PAYMENT_GATEWAYS,
  SERVICE_PAYMENT_STATUSES,
  SERVICE_PAYMENT_INSTALLMENT_STATUSES,
} from '@/constants/payment';
import ServiceOrderListFilterForm from './List/ServiceOrderListFilterForm.vue';
import ServiceOrderListFilterChip from './List/ServiceOrderListFilterChip.vue';
import _ from 'lodash';

@Component({
  components: {
    ServiceOrderListFilterForm,
    ServiceOrderListFilterChip,
  },
  computed: {
    ...mapState('ServiceOrder', {
      activeServiceOrder: 'activeServiceOrder',
    }),
    ...mapState('ServicePayment', {
      activeServicePayment: 'activeServicePayment',
    }),
  },
})
export default class ServiceOrderList extends Vue {
  @Prop({ default: true }) needHeader!: boolean;
  @Prop({ default: true }) needContentClass!: boolean;

  options = {
    page: 1,
    itemsPerPage: 10,
    query: null,
    orderBy: 'created_at',
    orderByDirection: 'desc',
    paymentStatuses: [],
    paymentMethod: null,
    businessOid: null,
    servicePaymentGid: null,
  };
  paymentMethods = METHODS;
  paymentGateways = PAYMENT_GATEWAYS;
  paymentStatuses = SERVICE_PAYMENT_STATUSES;
  installmentPaymentStatuses = SERVICE_PAYMENT_INSTALLMENT_STATUSES;
  additionalServices = '';

  showAdditionalService = false;

  headers = [
    { text: 'Order ID', value: 'gid', sortable: false },
    {
      text: 'Tax Number',
      value: 'service_payment.gid',
      sortable: false,
      width: '15%',
    },
    {
      text: 'Requested Business',
      value: 'business.name',
      align: 'left',
      sortable: false,
    },
    {
      text: 'Payment Method',
      value: 'service_payment.method',
      align: 'left',
      sortable: false,
    },
    {
      text: this.showAdditionalService ? 'Service Items' : 'Quantity',
      value: 'service_items',
      align: 'left',
      sortable: false,
    },
    {
      text: 'Payment Status',
      value: 'service_payment.status',
      align: 'left',
      sortable: false,
    },
    {
      text: 'Expiry Date',
      value: 'expire_at',
      align: 'left',
      sortable: false,
    },
    // { text: 'Actions', value: 'actions', align: 'left', sortable: false },
  ];

  isMounted = false;

  async beforeMount() {
    this.$store.dispatch('Business/all').then(() => {
      this.isMounted = true;
    });
  }

  handleFetch() {
    const options = {
      params: {
        search: this.options.query,
        page: this.options.page,
        per_page: this.options.itemsPerPage,
        sort:
          this.options.orderByDirection == 'desc'
            ? '-' + this.options.orderBy
            : this.options.orderBy,
        payment_statuses: this.options.paymentStatuses,
        payment_method: this.options.paymentMethod,
        business_oid: this.options.businessOid,
        service_payment_gid: this.options.servicePaymentGid,
        expand: ['service_items', 'service_payment', 'business'],
      },
    };
    return this.$store.dispatch('ServiceOrder/fetchList', options);
  }

  toRead(oid) {
    this.$router.push({
      name: 'admin-service-order-read',
      params: {
        serviceOrderOid: oid,
      },
    });
  }

  handleClick(item) {
    this.toRead(item.object_id);
  }

  getASsessmentItem(serviceItems) {
    return serviceItems.find((item) => item['key'] === 'assessment');
  }

  pluckGid(children) {
    return _.map(children, 'gid').join(', ');
  }
}
